module.exports = __webpack_public_path__ + "img/bhutan.f769294.webp";